<template>
	<div>
		<div class="kuandu">
			<div class="filter-inline-panel cle">
				<div class="list-opinion fr">
					<!-- <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button> -->
			        <el-button type="primary" size="mini" v-if="hasBtn('refund')" @click="refund_is=true">{{$t('index.refund')}}</el-button>
				</div>
			</div>
			<el-form :model="order_info" size="mini" label-width="80px" label-position="top" >
				<el-row class="tree-content" :gutter="20">
				  <el-col :span="6">
					<el-form-item :label="$t('order.no')" data-name="订单号">
						<el-input v-model="order_info.order_id" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.tel')" data-name="电话">
						<el-input v-model="order_info.tel" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.create_time')" data-name="购买时间">
						<el-input :value="getTime_us(order_info.create_time,'mmddyyyy')+'  '+getTime_us(order_info.create_time,'hh:ii')" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.price')" data-name="金额">
						<el-input v-model="order_info.price" readonly></el-input>
					</el-form-item>
				  </el-col>
				 <!--  <el-col :span="6">
					<el-form-item :label="$t('order.score')" data-name="积分">
						<el-input v-model="order_info.use_score" readonly></el-input>
					</el-form-item>
				  </el-col> -->
				  <el-col :span="6">
					<el-form-item :label="$t('order.discount')" data-name="优惠金额">
						<el-input :value="'-'+amount_jisuan(order_info)" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.total')" data-name="实付金额">
						<el-input v-model="order_info.pay_price" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.refund')" data-name="退款金额">
						<el-input v-model="order_info.refund_amount" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.payment')" data-name="支付方式">
						<el-input v-model="order_info.pay_method" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
					<el-form-item :label="$t('order.letter')" data-name="确认信">
						<el-input :value="order_info.confirmation==1?'YES':'NO'" readonly></el-input>
					</el-form-item>
				  </el-col>
				  <el-col :span="12">
					<el-form-item :label="$t('order.discount_name')" data-name="使用优惠券名称">
						<el-input :value="use_coupon_list_f()" readonly></el-input>
					</el-form-item>
				  </el-col>
				</el-row>
			</el-form>
			<div v-if="course_list.length">
				<!-- <div class="pp1">{{$t('order.classes_name')}}</div> -->
				<el-table :data="course_list" border size="mini">
				  <el-table-column  align="center" :label="$t('order.name')" data-name="主题">
					<template slot-scope="scope">
						<a target="_blank" class="clo3" :href="API_URL+'#/course_info?id='+scope.row.course_id">{{lang=='cn'?scope.row.name_cn:scope.row.name}}</a>
					</template>
				  </el-table-column>
				  <el-table-column prop="children_name" align="center" :label="$t('order.children')" data-name="学生">
					<template slot-scope="scope">
						<p v-for="(item,index) in scope.row.children" :key="index">{{item.name_cn}} {{item.name}}（{{item.age>50?'成人':item.age+'岁'}}）</p>
					</template>
				  </el-table-column>

					<el-table-column prop="surplus" align="center" :label="$t('course_index.max_people')" data-name="班级规模" width="110">
						<template slot-scope="{row}">{{row.student_num}}/{{row.course_info.max_people}}</template>
					</el-table-column>
				  <el-table-column :prop="lang=='cn'?'teacher.name_cn':'teacher.name'" align="center" :label="$t('order.teacher')" data-name="老师"></el-table-column>
				  <el-table-column align="center" :label="$t('parent_index.seller')" data-name="销售">
				  	<template slot-scope="{row}">
						<div v-if="row.course_info">{{courseSellerList[row.course_info.course_seller_id]}}</div>
				  	</template>
				  </el-table-column>
				  <el-table-column align="center" :label="$t('course_index.cate')" data-name="分类">
				  	<template slot-scope="{row}">
						<div v-if="row.course_info">{{cate_list[row.course_info.cate_id]}}</div>
				  	</template>
				  </el-table-column>

				  <el-table-column align="center" :label="$t('order.date')" data-name="日期" width="200">
					<template slot-scope="scope">{{getTime_us(scope.row.course_info.start_date,'mmddyyyy')}} ~ {{getTime_us(scope.row.course_info.end_date,'mmddyyyy')}}</template>
				  </el-table-column>
				  <el-table-column align="center" :label="$t('order.time')" data-name="时间">
					<template slot-scope="scope">{{getTime_us(scope.row.course_info.start_time,'hh:ii')}} ~ {{getTime_us(scope.row.course_info.end_time,'hh:ii')}}</template>
				  </el-table-column>
				  <el-table-column align="center" :label="$t('order.on_date')" data-name="不上课日期">
					<template slot-scope="scope">
						{{scope.row.course_info.no_course_dates | no_course_dates_f(this_)}}
					</template>
				  </el-table-column>
				  <el-table-column prop="course_info.center_id" :label="$t('order.center')" align="center" :key="9" data-name="学习中心">
				  	<template slot-scope="{row}">{{learnCenter[row.course_info.center_id]}}</template>
				  </el-table-column>
				  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10" data-name="金额"></el-table-column>
				  <el-table-column prop="noon_price" label="是否需要午托" align="center" :key="11" data-name="金额">
				  	<template slot-scope="{row}">{{row.noon_price>0?'是':'否'}}</template>
				  </el-table-column>
				  <el-table-column prop="trip_course_id" label="是否试听" align="center" :key="12" data-name="金额">
				  	<template slot-scope="{row}">{{row.trip_course_id>0?'是':'否'}}</template>
				  </el-table-column>
				  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="20" data-name="优惠金额"></el-table-column>
				  <!-- <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12"></el-table-column> -->
				  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="30" data-name="实付金额"></el-table-column>
				  <el-table-column align="center" :label="$t('index.operation')" width="140" data="操作" :key="40">
					<template slot-scope="scope" fixed="right">
						<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua(scope.row)">{{$t('index.copy')}}</el-button>
						<el-button type="danger" size="mini" class="tag-read" v-if="scope.row.status!=9" @click="click_cancel(scope.row)">{{$t('index.cancel')}}</el-button>
					</template>
				  </el-table-column>
				</el-table>
			</div>
			<div v-if="camp_list.length">
				<div class="pp1">{{$t('order.camps')}}</div>
				<el-table :data="camp_list" border size="mini">
				  <el-table-column align="center" :label="$t('order.subject')">
						<template slot-scope="scope">
							<a target="_blank" class="clo3" :href="API_URL+'#/course_camps_info?id='+scope.row.camp_id">{{lang=='cn'?scope.row.theme_cn:scope.row.theme}}</a>
						</template>
				  </el-table-column>
				  <el-table-column prop="children_name" align="center" :label="$t('order.children')">
					<template slot-scope="scope">
						<span v-for="(items,indexs) in scope.row.children" :key="indexs">{{items.name}}{{items.age}}y</span>
					</template>
				  </el-table-column>
				  <el-table-column :prop="lang=='cn'?'teacher_name_cn':'teacher_name'" align="center" :label="$t('order.teacher')"></el-table-column>
				  <el-table-column align="center" :label="$t('order.date')">
					<template slot-scope="scope">{{getTime_us(scope.row.start_date_time,'mmdd')}}-{{getTime_us(scope.row.end_date_time,'mmddyyyy')}}</template>
				  </el-table-column>
				  <el-table-column align="center" :label="$t('order.time')">
					<template slot-scope="scope">{{getTime_us(scope.row.start_time,'ampm')}}-{{getTime_us(scope.row.end_time,'ampm')}}</template>
				  </el-table-column>
				  <el-table-column align="center" :label="$t('order.on_date')">
					<template slot-scope="scope">{{scope.row.no_course_date | no_course_dates_f(this_)}}</template>
				  </el-table-column>
				  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
				  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11">
				  	<template slot-scope="scope">-{{scope.row.discounts_all}}</template>
				  </el-table-column>
				  <!-- <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12">
				  	<template slot-scope="scope">-{{scope.row.score}}</template>
				  </el-table-column> -->
				  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
				  <el-table-column align="center" :label="$t('index.operation')" data="操作">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_xalingy(scope.row)">{{$t('index.copy')}}</el-button>
					</template>
				  </el-table-column>
				</el-table>
			</div>
			<div v-if="private_list.length">
				<div class="pp1">{{$t('order.private')}}</div>
				<el-table :data="private_list" border size="mini">
				  <el-table-column align="center" :label="$t('order.subject')">
						<template slot-scope="scope">
							<a target="_blank" class="clo3" :href="API_URL+'#/course_private_info?id='+scope.row.course_info.id">{{lang=='cn'?scope.row.name_cn:scope.row.name}}</a>
						</template>
				  </el-table-column>
				  <el-table-column prop="children_name" align="center" :label="$t('order.children')">
					<template slot-scope="scope">
						<span v-for="(items,indexs) in scope.row.children" :key="indexs">{{items.name}}{{items.age}}y</span>
					</template>
				  </el-table-column>
				  <el-table-column :prop="lang=='cn'?'teacher.name_cn':'teacher.name'" align="center" :label="$t('order.teacher')"></el-table-column>
				  <el-table-column align="center" :label="$t('order.time')">
					<template slot-scope="scope">{{getTime_us(scope.row.start_time,'mmddyyyyampm')}}-{{getTime_us(scope.row.end_time,'ampm')}}</template>
				  </el-table-column>
				  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
				  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11">
				  	<template slot-scope="scope">-{{scope.row.discounts_all}}</template>
				  </el-table-column>
				  <!-- <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12">
				  	<template slot-scope="scope">-{{scope.row.score}}</template>
				  </el-table-column> -->
				  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
				  <el-table-column align="center" :label="$t('index.operation')" data="操作">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_sijiaok(scope.row)">{{$t('index.copy')}}</el-button>
					</template>
				  </el-table-column>
				</el-table>
			</div>
			<div v-if="activity_list.length">
				<div class="pp1">{{$t('order.activity')}}</div>
				<el-table :data="activity_list" border size="mini">
				  <el-table-column align="center" :label="$t('order.subject')">
						<template slot-scope="scope">
							<a target="_blank" class="clo3" :href="API_URL+'#/course_activity_info?id='+scope.row.course_info.id">{{lang=='cn'?scope.row.name_cn:scope.row.name}}</a>
						</template>
				  </el-table-column>
				  <el-table-column prop="children_name" align="center" :label="$t('order.children')">
					<template slot-scope="scope">
						<span v-for="(items,indexs) in scope.row.children" :key="indexs">{{items.name}}{{items.age}}y</span>
					</template>
				  </el-table-column>
				  <el-table-column prop="price" :label="$t('order.price')" align="center" :key="10"></el-table-column>
				  <el-table-column prop="discounts_all" :label="$t('order.discount')" align="center" :key="11">
				  	<template slot-scope="scope">-{{scope.row.discounts_all}}</template>
				  </el-table-column>
				  <!-- <el-table-column prop="score" :label="$t('order.score')" align="center" :key="12">
				  	<template slot-scope="scope">-{{scope.row.score}}</template>
				  </el-table-column> -->
				  <el-table-column prop="pay_price" :label="$t('order.total')" align="center" :key="13"></el-table-column>
				  <el-table-column align="center" :label="$t('index.operation')" data="操作">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" class="tag-read" @click="copy" :data-clipboard-text="geshihua_activity(scope.row)">{{$t('index.copy')}}</el-button>
					</template>
				  </el-table-column>
				</el-table>
			</div>
			<div v-if="refund_list.length">
				<div class="pp1">{{$t('order.refund_name')}}</div>
				<el-table :data="refund_list" border size="mini">
					<el-table-column prop="order_id" align="center" label="ID"></el-table-column>
					<el-table-column prop="pay_method" align="center" :label="$t('order.payment')"></el-table-column>
					<el-table-column prop="price" align="center" :label="$t('order.refund')"></el-table-column>
					<el-table-column prop="user_name" align="center" :label="$t('journal.user_name')"></el-table-column>
					<el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
						<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
					</el-table-column>
					<!-- <el-table-column prop="action" align="center" :label="$t('index.operation')"></el-table-column> -->
					<el-table-column prop="remarks" align="center" :label="$t('order.notes')"></el-table-column>
				</el-table>
			</div>
			<el-dialog :title="$t('order.refund_title')" width="500px" append-to-body :close-on-click-modal="false" :visible="refund_is" @close="refund_is = false">
				<el-form :model="order_info" size="mini" label-width="80px" label-position="top">
					<el-row class="tree-content" :gutter="20">
					  <el-col :span="12">
						<el-form-item :label="$t('order.total')" data-name="支付金额">
							<div class="el-form-item__content">
								<div class="w100 el-input el-input--mini"><div class="el-input__inner">{{order_info.pay_price}}</div></div>
							</div>
						</el-form-item>
					  </el-col>
					  <el-col :span="12">
						<el-form-item :label="$t('order.refund')" data-name="退款金额">
							<el-input-number v-model="filterForm.refund_amount" :precision="2" :min="0" :max="tuikuanjine(order_info)"></el-input-number>
						</el-form-item>
					  </el-col>
					  <el-col :span="24">
						<el-form-item :label="$t('order.notes')" data-name="备注">
							<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6}" :placeholder="$t('index.pleaseInput')" v-model="filterForm.notes"></el-input>
						</el-form-item>
					  </el-col>
				  </el-row>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="refund_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="refund_f('editForm')">{{$t('index.submit')}}</el-button>
			  </div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import Clipboard from 'clipboard'; 
export default {
	name:'no_cache',

	props:{
		order_id: {
			type:[String,Number],
			default:''
		}
	},
	data() {
		return {
			this_:this,
			// order_id: '',
			camp_list: [],
			private_list: [],
			course_list: [],
			activity_list: [],
			use_coupon_list: [],
			order_info:{
				user_info:{}
			},
			refund_list:[],
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			refund_is:false,
			payment:[
				{
					name:'Credit Card (Stripe)',
					id:'2'
				},
				{
					name:'PayPal',
					id:'1'
				}
			],
			API_URL:process.env.API_URL,
			filterForm:{
				refund_amount:'',
				notes:'',
			},
			learnCenter:{},
			cate_list:{},
			courseSellerList:{},
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			this.$post('courseScreen', {}).then((res) => {
				this.learnCenter=this.for_code(res.learnCenter,'id');
				this.cate_list=this.for_code(res.cate_list,'id');
				this.courseSellerList=this.for_code_name(res.courseSellerList,'id');
			})
		},
		for_code_name(list,name){
			var new_list=[];
		    for (var i = 0; i < list.length; i++) {
		        new_list[list[i][name]] = list[i].name;
		    }
		    return new_list;
		},
		init(data){
			var this_ = this;
			var url = "orderInfo";
			var datas = {
				order_id:this_.order_id,
			};
			this_.$post(url, datas).then((res) => {
				this_.camp_list = res.camp_list||{};
				this_.private_list = res.private_list||{};
				this_.course_list = res.course_list||[];
				this_.activity_list = res.activity_list||[];
				this_.order_info = res.order_info;
				this_.use_coupon_list = res.use_coupon_list||[];
			})
			var url = "adminRefundRecord";
			var datas = {
				page:1,
				num: 1000,
				order_id:this_.order_id
			};
			this_.$post(url, datas).then((res) => {
				this_.refund_list = res.list;
			})
		},
		refund_f(){
			var this_ = this;
			var url = "refundOrder";
			var datas = {
				order_id:this_.order_info.order_id,
				refund_amount:this_.filterForm.refund_amount,
				remarks:this_.filterForm.notes,
			};
			this_.$confirm(this_.$t('order.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.operation_success'));
					this_.refund_is=false;
					this_.init();
				})
			}).catch(() => {});
		},
		// 优惠金额
		amount_jisuan(data){
			var discounts=data.discounts?parseFloat(data.discounts):0;
			var coupon_price=data.coupon_price?parseFloat(data.coupon_price):0; 
			var yaoqing_price=data.yaoqing_price?parseFloat(data.yaoqing_price):0;
			// var use_score=data.use_score?parseFloat(data.use_score):0;
			var zhekou=data.zhekou?parseFloat(data.zhekou):0;
			var zhi= discounts+coupon_price+yaoqing_price+zhekou;
			return zhi.toFixed(2);
		},
		tuikuanjine(){
			var data=this.order_info;
			var pay_price=data.pay_price||0;
			var refund_amount=data.refund_amount||0;
			var max=parseFloat(pay_price);
			return max
		},
		use_coupon_list_f(){
			var this_=this;
			var use_coupon_list=this.use_coupon_list;
			var name='';
			use_coupon_list.forEach(function(e,i) {
				name+=(i==0?'':',')+(this_.lang=='cn'?e.name_cn:e.name);
			});
			return name
		},
		// 取消
		click_cancel(data){
			this.$prompt(this.$t('index.confirm_cancel'), this.$t('index.tips'), {
				inputPlaceholder:'备注',
				inputType:'textarea'
			}).then(({ value }) => {
				this.$post('order/cancelorder',{order_id:data.order_id,course_id:data.course_id,remarks:value||''}).then((res) => {
					this.$message.success(this.$t('index.operation_success'));
					this.init();
				})
			}).catch(() => {});
		},
		// 复制
		copy(){
			var this_ = this;
			var clipboard = new Clipboard('.tag-read');
			clipboard.on('success', e => {
				this_.$message.success(this_.$t('index.copy_success'));
				clipboard.destroy()
			})
			clipboard.on('error', e => {
				this_.$message.success(this_.$t('index.copy_error'));
				clipboard.destroy()
			})
		},
		geshihua(data){
			var name="#"+data.order_id+' '+(this.getTime_us(data.course_info.start_date,'mmddyyyy'))+'-'+(this.getTime_us(data.course_info.end_date,'mmddyyyy'))+','+(this.getTime_us(data.course_info.start_time,'hh:ii'))+'-'+(this.getTime_us(data.course_info.end_time,'hh:ii'))+','+(this.lang=='cn'?data.teacher.name_cn:data.teacher.name)+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
		geshihua_xalingy(data,camp_list){
			var name="#"+data.transaction_id+' '+(this.getTime_us(data.start_date_time,'mmddyyyy'))+'-'+(this.getTime_us(data.end_date_time,'mmddyyyy'))+','+(this.getTime_us(data.start_time,'hh:ii'))+'-'+(this.getTime_us(data.end_time,'hh:ii'))+','+(this.lang=='cn'?data.teacher_name_cn:data.teacher_name)+','+(this.lang=='cn'?data.theme_cn:data.theme);
			return name;
		},
		geshihua_sijiaok(data,camp_list){
			var name="#"+data.order_id+' '+(this.getTime_us(data.start_time,'mmddyyyyampm'))+'-'+(this.getTime_us(data.end_time,'ampm'))+','+(this.lang=='cn'?data.teacher.name_cn:data.teacher.name)+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
		geshihua_activity(data,camp_list){
			var name="#"+data.order_id+','+(this.lang=='cn'?data.name_cn:data.name);
			return name;
		},
		router(url,query){
			this.$router.push({path:url,query:query})
		},

	},
	// 过滤器
	filters: {
		no_course_dates_f(v,this_){
			if (v) {
				var array=v.split(',');
				var zhi=[];
				array.forEach(function(e,i) {
					if (e) {
						zhi[i]=this_.getTime_us(e,'mmddyyyy');
					}
				});
				return zhi.join(',');
			}else{
				return '';
			}
		},
	}
}
</script>
<style scoped>
.kuandu{
	width: 100%;
	/* max-width: 1200px; */
}
.pp1{
	text-align: center;
	line-height: 40px;
	margin-top: 10px;
}
.clo3{
	color: #ff0000;
}
.kongb{
	width: 100%;
	height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/info.vue